module.exports = "<util-tabs [app]=\"app\"></util-tabs>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/rts/rts.component.html
// module id = ./src/app/pages/rts/rts.component.html
// module chunks = main